import type { AdmissionOfficeCountry } from "../../admissionOfficeCountry";
import { templatesMaltaEnCertificateSettings } from "@/src/constants/AdmissionOffice/Malta/AOMaltaEnConsts";

/** Extend when Certificate / Authorization flows exist for other countries. */
export type CertificateBasicCountry = Extract<AdmissionOfficeCountry, "malta">;

export type CertificateBasicRegistryEntry = {
  certificateTemplates: typeof templatesMaltaEnCertificateSettings;
};

export const CERTIFICATE_BASIC_REGISTRY: Record<CertificateBasicCountry, CertificateBasicRegistryEntry> = {
  malta: {
    certificateTemplates: templatesMaltaEnCertificateSettings,
  },
};
